import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../config/axios';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [logoMessage, setLogoMessage] = useState('FBAJANS İLE KOLAY E-TİCARET'); // Logo mesajı state'i
  const [logoFile, setLogoFile] = useState(null); // Logo dosyası state'i
  
  const navigate = useNavigate();

  // Logo mesajını backend'den çek ve title'ı ayarla
  useEffect(() => {
    // Tarayıcı title'ını ayarla
    document.title = 'FBAJANS WhatsApp Business - Giriş';
    
    const fetchLogoMessage = async () => {
      try {
        const response = await fetch('/api/admin/settings');
        const data = await response.json();
        if (data.success && data.data.logo_message) {
          setLogoMessage(data.data.logo_message);
        }
        if (data.success && data.data.logo_file) {
          setLogoFile(data.data.logo_file);
        }
      } catch (error) {
        console.error('Logo mesajı çekilemedi:', error);
      }
    };

    fetchLogoMessage();
  }, []);

  // Admin token ile otomatik login kontrolü
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const adminToken = urlParams.get('admin_token');
    const slug = urlParams.get('slug');
    const expires = urlParams.get('expires');
    
    if (adminToken && slug) {
      // Token süresi kontrolü
      if (expires) {
        const expiresTime = new Date(expires).getTime();
        if (expiresTime < Date.now()) {
          setError('Admin login token\'ı süresi dolmuş. Lütfen tekrar deneyin.');
          return;
        }
      }
      
      // ÖNEMLİ: Admin token ile login yaparken mevcut session'ı temizle
      // Çünkü admin panelinden geldiğimiz için sessionStorage'da admin bilgileri olabilir
      sessionStorage.clear();
      
      // Otomatik login yap
      handleAdminLogin(adminToken, slug);
    }
  }, []);

  // Admin token ile otomatik login
  const handleAdminLogin = async (token, slug) => {
    setLoading(true);
    setError('');
    
    try {
      // Admin token ile login endpoint'ini çağır
      const response = await axios.post('/auth/admin-login', {
        token: token,
        slug: slug
      });
      
      if (response.data.success) {
        // Başarılı login
        sessionStorage.setItem('authToken', 'test-token');
        sessionStorage.setItem('userId', response.data.user.id);
        sessionStorage.setItem('username', response.data.user.username);
        sessionStorage.setItem('userRole', response.data.user.role);
        sessionStorage.setItem('firmSlug', response.data.user.username);
        
        // URL'den admin token parametrelerini temizle
        window.history.replaceState({}, document.title, '/login');
        
        navigate('/dashboard');
      } else {
        setError('Admin login başarısız: ' + (response.data.message || 'Bilinmeyen hata'));
      }
    } catch (error) {
      console.error('Admin login error:', error);
      setError('Admin login hatası: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  // Eğer zaten login ise redirect et (admin token kontrolünden SONRA çalışmalı)
  useEffect(() => {
    // Admin token kontrolü yapılıyorsa, redirect etme
    const urlParams = new URLSearchParams(window.location.search);
    const adminToken = urlParams.get('admin_token');
    if (adminToken) {
      // Admin token varsa, redirect yapma (admin login işlemi yapılacak)
      return;
    }
    
    const token = sessionStorage.getItem('authToken');
    const userRole = sessionStorage.getItem('userRole');
    
    // Sadece aynı sekmede giriş yapılmışsa redirect et
    if (token && userRole) {
      console.log('🔍 Mevcut oturum tespit edildi:', { token: !!token, userRole });
      
      if (userRole === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    }
  }, [navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Hata mesajını temizle
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('🔍 Login isteği gönderiliyor...');
      console.log('🔍 Form data:', formData);
      console.log('🔍 Axios baseURL:', axios.defaults.baseURL);
      
      const response = await axios.post('/auth/login', formData);
      const data = response.data;
      
      // Debug: Console'a response'u yazdır
      console.log('✅ API Response:', data);
      console.log('✅ Response status:', response.status);
      console.log('✅ Data status:', data.status);

             if (data.success === true) {
         // Başarılı login - sessionStorage kullan (sekme bazlı)
         sessionStorage.setItem('authToken', 'test-token'); // Backend'de token yok, test için
         sessionStorage.setItem('userId', data.user.id);
         sessionStorage.setItem('username', data.user.username);
         sessionStorage.setItem('userRole', data.user.role);
         sessionStorage.setItem('firmSlug', data.user.username);
        
        // Normal yönlendirme
        if (data.user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/dashboard');
        }
      } else {
        setError(data.message || 'Giriş başarısız. Kullanıcı adı veya şifre hatalı.');
      }
    } catch (error) {
      console.error('Login error:', error);
      
      // Axios interceptor error.response.data'yı döndürüyor
      if (error.message && error.message.includes('onaylanmadı')) {
        setError(error.message);
      } else if (error.message && error.message.includes('hatalı')) {
        setError(error.message);
      } else {
        setError(error.message || 'Sunucu hatası. Lütfen daha sonra tekrar deneyin.');
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '40px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        {/* Logo */}
        <div style={{ marginBottom: '30px' }}>
          <div style={{ marginBottom: '30px' }}>
            <img 
              src={logoFile ? `/api/logo/${logoFile}` : "/logo.png"} 
              alt="FBAJANS Logo" 
              style={{ 
                maxHeight: '60px', 
                width: 'auto'
              }} 
            />
          </div>
        </div>

        {/* Error Message */}
        {error && (
          <div style={{
            background: '#fee',
            color: '#c53030',
            padding: '12px',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            border: '1px solid #fed7d7'
          }}>
            ⚠️ {error}
          </div>
        )}

        {/* Login Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <input
              type="text"
              name="username"
              placeholder="Kullanıcı Adı (Firma Slug)"
              value={formData.username}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                border: '2px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.3s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#667eea'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          <div style={{ marginBottom: '25px' }}>
            <input
              type="password"
              name="password"
              placeholder="Şifre"
              value={formData.password}
              onChange={handleInputChange}
              required
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                border: '2px solid #e2e8f0',
                borderRadius: '10px',
                outline: 'none',
                transition: 'border-color 0.3s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#667eea'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '15px',
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              background: loading ? '#a0aec0' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              borderRadius: '10px',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.3s',
              transform: loading ? 'none' : 'translateY(0)',
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }
            }}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                Giriş Yapılıyor...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt" style={{ marginRight: '8px' }}></i>
                Giriş Yap
              </>
            )}
          </button>

          {/* Kayıt Ol Butonu */}
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <button
              type="button"
              onClick={() => navigate('/register')}
              style={{
                width: '100%',
                padding: '15px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#667eea',
                background: 'transparent',
                border: '2px solid #667eea',
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.3s',
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#667eea';
                e.target.style.color = 'white';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 25px rgba(102, 126, 234, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'transparent';
                e.target.style.color = '#667eea';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              <i className="fas fa-user-plus" style={{ marginRight: '8px' }}></i>
              Kayıt Ol
            </button>
          </div>
        </form>

        {/* Forgot Password Link */}
        <div style={{ marginTop: '20px' }}>
          <button
            type="button"
            onClick={() => navigate('/forgot-password')}
            style={{
              background: 'none',
              border: 'none',
              color: '#667eea',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            🔐 Şifremi Unuttum
          </button>
        </div>


        {/* Footer */}
        <div style={{
          marginTop: '25px',
          padding: '20px 0',
          borderTop: '1px solid #e2e8f0',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '16px',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: '5px'
          }}>
            FBAJANS WhatsApp Business
          </div>
          <div style={{
            fontSize: '13px',
            color: '#666',
            marginBottom: '8px'
          }}>
            Otomatik WhatsApp Mesajlaşma Paneli
          </div>
          <div style={{
            fontSize: '11px',
            color: '#999'
          }}>
            © 2025 FBAJANS - Tüm hakları saklıdır
          </div>
        </div>

      </div>
    </div>
  );
};

export default LoginPage; 